import { Controller } from "@hotwired/stimulus"

// แถบชิปเลือกหมวดของดวงรายเดือน: กดกระโดดไปหมวดที่ต้องการ + ไฮไลต์หมวดที่กำลังอ่านอยู่
export default class extends Controller {
  static targets = ["chip"]

  connect() {
    this.sections = this.chipTargets
      .map((chip) => document.getElementById(`topic-${chip.dataset.topic}`))
      .filter(Boolean)

    this.onScroll = () => this.#highlightCurrent()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.#highlightCurrent()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  // Turbo ดักคลิกลิงก์ #anchor ไปทำ visit เอง เลยต้องคุมการกระโดดเองทั้งหมด
  // (ได้ผลพลอยได้คือเว้นระยะใต้แถบชิปได้พอดีโดยไม่ต้องพึ่ง scroll-margin)
  jump(event) {
    event.preventDefault()

    const topic = event.currentTarget.dataset.topic
    const section = document.getElementById(`topic-${topic}`)
    if (!section) { return }

    const top = section.getBoundingClientRect().top + window.scrollY - this.#chipsBarHeight()
    window.scrollTo({ top, behavior: "smooth" })
    history.replaceState(null, "", `#topic-${topic}`)
  }

  #chipsBarHeight() {
    return this.element.getBoundingClientRect().height
  }

  // หมวดที่กำลังอ่าน = หมวดสุดท้ายที่หัวข้อเลื่อนพ้นแถบชิปขึ้นไปแล้ว
  #highlightCurrent() {
    const line = this.#chipsBarHeight() + 8
    let current = this.sections[0]

    this.sections.forEach((section) => {
      if (section.getBoundingClientRect().top <= line) { current = section }
    })

    // หมวดท้าย ๆ ถ้าเนื้อหาสั้นจะเลื่อนขึ้นไปชนแถบชิปไม่ได้ (สุดหน้าเสียก่อน)
    // พอเลื่อนถึงก้นหน้าแล้วให้ถือว่ากำลังอ่านหมวดสุดท้ายที่มองเห็น ไม่งั้นชิปค้างอยู่หมวดก่อนหน้า
    if (this.#scrolledToBottom()) {
      current = this.sections.findLast(
        (section) => section.getBoundingClientRect().top < window.innerHeight * 0.6
      ) || current
    }

    this.chipTargets.forEach((chip) => {
      chip.classList.toggle("active", `topic-${chip.dataset.topic}` === current?.id)
    })

    this.#revealActiveChip()
  }

  // แถบชิปกว้างเกินจอ ชิปท้าย ๆ เลยตกขอบขวา — เลื่อนแถบตามหมวดที่อ่านอยู่ ไม่งั้นดูไม่ออกว่าอยู่ตรงไหน
  #revealActiveChip() {
    const active = this.chipTargets.find((chip) => chip.classList.contains("active"))
    if (!active || active === this.lastRevealed) { return }
    this.lastRevealed = active

    const bar = this.element.getBoundingClientRect()
    const chip = active.getBoundingClientRect()
    const overflowRight = chip.right - bar.right
    const overflowLeft = bar.left - chip.left

    if (overflowRight > 0) {
      this.element.scrollBy({ left: overflowRight + 16, behavior: "smooth" })
    } else if (overflowLeft > 0) {
      this.element.scrollBy({ left: -(overflowLeft + 16), behavior: "smooth" })
    }
  }

  #scrolledToBottom() {
    const remaining =
      document.documentElement.scrollHeight - window.scrollY - window.innerHeight
    return remaining <= 2
  }
}
